import {
  Component,
  AfterViewInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
} from '@angular/core';
import * as EasyMDE from 'easymde';

@Component({
  selector: 'app-markdown-editor',
  templateUrl: './markdown-editor.component.html',
  styleUrls: ['./markdown-editor.component.scss'],
})
export class MarkdownEditorComponent implements AfterViewInit, OnDestroy {
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();
  @ViewChild('textareaRef', { static: true })
  textareaRef!: ElementRef<HTMLTextAreaElement>;

  private easyMDE!: EasyMDE;

  ngAfterViewInit(): void {
    this.easyMDE = new EasyMDE({
      autoDownloadFontAwesome: false,
      element: this.textareaRef.nativeElement,
      initialValue: this.value || '',
      spellChecker: false,
      minHeight: '100px',
      placeholder: 'Write something...',
      toolbar: [
        'undo',
        '|',
        'bold',
        'italic',
        '|',
        'quote',
        'code',
        '|',
        'unordered-list',
        'ordered-list',
        '|',
        'heading-1',
        'heading-2',
        'heading-3',
        '|',
        'link',
        'image',
        '|',
        'side-by-side',
      ],
    });

    this.easyMDE.codemirror.on('change', () => {
      const markdown = this.easyMDE.value();
      this.valueChange.emit(markdown);
    });
  }

  ngOnDestroy(): void {
    this.easyMDE?.toTextArea();
    this.easyMDE = null as any;
  }
}
